module.exports = __webpack_public_path__ + "static/media/why-choose-us.1a91329a.png";